import { http_post } from 'api/BaseURLAxios';
import { MANUAL_ASSISTANT_QUERY } from 'api/urlConstants';

export interface ManualAssistantQueryRequest {
    user_query: string;
    user_id: string;
    user_persona_name: string;
}

export interface ManualAssistantCitation {
    document_name: string;
    page_number: string;
    section_title: string;
}

export interface ManualAssistantGroundedResponse {
    steps: string[];
    citation: ManualAssistantCitation;
    provider_used: string;
}

export interface ManualAssistantErrorResponse {
    error: string;
    message: string;
}

export type ManualAssistantQueryResponse = ManualAssistantGroundedResponse | ManualAssistantErrorResponse;

export const getManualAssistantQueryPath = (): string => MANUAL_ASSISTANT_QUERY;

export const queryManualAssistant = async (
    body: ManualAssistantQueryRequest,
): Promise<ManualAssistantQueryResponse> => {
    return http_post(MANUAL_ASSISTANT_QUERY, body) as Promise<ManualAssistantQueryResponse>;
};
